<template>
    <div>
        <div id="liveChatContainer"></div>
    </div>
</template>
 
<script>
/* eslint-disable */
import { mapGetters } from 'vuex';
export default {
    name: "TheLiveChat",
    computed: {
     ...mapGetters({
        liveChatHTML: 'liveChatHTML',
        headerHTML: 'headerHTML'
      })
    },
    methods: {
        getHeaderData(data) {
            if (data) {
                this.$store.dispatch('getLiveChatHTML');
            }
        },
        assignLiveChatHTML(value) {
            const body = document.getElementsByTagName('body')[0];
            let liveChatHtml = document.getElementById('liveChatContainer');

            value.str = value.str?.replaceAll('<link rel="stylesheet" href="https://aem-qa.microchip.com:8443/etc.clientlibs/mchp/clientlibs/clientlib-site/components/chaticon.min.ACSHASHfa49e71044e53da3a2d9121c595ac309.css" type="text/css">', '');
            value.str = value.str?.replaceAll('<link rel="stylesheet" href="https://aem-qa.microchip.com:8443/etc.clientlibs/mchp/clientlibs/clientlib-site/components/chatcontainer.min.ACSHASH774e916d35f8176d1fa9d26e71553212.css" type="text/css">', '')


            if (value.str?.length > 10) {

                liveChatHtml.innerHTML = value.str;
                const salesForceChatConfig = document.getElementById('salesforce-chat-config');


                // JS libs appending to body after HTML rendered //
                if (salesForceChatConfig != null || salesForceChatConfig != undefined) {
                    for (let i = 0; i < value.js.length; i++) {
                        const script = document.createElement('script');
                        script.type = 'text/javascript';
                        script.src = value.js[i];
                        script.async = false;
                        body.appendChild(script);
                    }
                }

            }


            try {
                setTimeout(function () {
                    const charts = document.querySelectorAll('[data-chartid]');
                }, 0);
            } catch (err) {
                //Not to stop the app load
            }
        }
    },
    watch: {
        headerHTML: [{
            handler: 'getHeaderData',
            deep: true,
        }],
        liveChatHTML: [{
            handler: 'assignLiveChatHTML',
            deep: true,
        }],
    }
}
</script>
